require("expose-loader?dc!./src/index.js")



// WEBPACK FOOTER //
// ./index.js